import * as constants from '@/assets/constants/sbkConstants'
import {REGEX_DATE_FORMAT} from "@/assets/constants/sbkConstants";

export const checkDateFormat = (value: string) => {
    return value.match(REGEX_DATE_FORMAT)
}

export const getCurrentDate = () => new Date(new Date().setHours(0, 0, 0, 0));


export const getFormattedSelectedDate = (value: string): Date | null => {
    const dateArray = value.match(constants.REGEX_DATE_FORMAT);

    if (dateArray) {
        const day = parseInt(dateArray[1]);
        const month = parseInt(dateArray[3]);
        const year = parseInt(dateArray[5]);

        return new Date(year, month - 1, day);
    }

    return null;
}

export const getChecksum = (digits: string): number => {
    const splittedDigits = digits.split('')

    const generatedChecksumObject = splittedDigits.reduce(
        (cs, currentValue, index) => {
            if (index < cs.offset + 7) {
                return {
                    ...cs,
                    checksumString: `${cs.checksumString}${currentValue}`,
                }
            }

            const checksum = parseInt(cs.checksumString, 10) % 97

            return {
                ...cs,
                checksum: checksum,
                checksumString: `${checksum}${splittedDigits[index]}`,
                offset: cs.offset + 7,
            }
        },
        {
            checksum: 0,
            checksumString: '',
            offset: 2,
        }
    )

    return parseInt(generatedChecksumObject.checksumString, 10) % 97
}